import React, { forwardRef } from 'react';

import { type XCSS, xcss } from '@atlaskit/primitives';

import { THead as PTHead, type THeadProps } from '../../ui/primitives/thead';

const THeadBaseStyles = xcss({
	position: 'sticky',
	//@ts-expect-error suggested options do not have value equivalent to 2
	zIndex: 2,
	inset: 'space.0',
	border: 'none',
	backgroundColor: 'color.background.input.hovered',
	borderTopLeftRadius: '7px',
	borderTopRightRadius: '7px',
	overflow: 'hidden',
	'::before': {
		content: '""',
		position: 'absolute',
		top: 'space.0',
		left: 'space.0',
		backgroundColor: 'color.background.neutral',
	},
});

export const THead = forwardRef<HTMLTableSectionElement, THeadProps>(
	({ children, xcss: customXcss, ...props }, ref) => {
		return (
			// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
			<PTHead xcss={[THeadBaseStyles, customXcss as XCSS]} ref={ref} {...props}>
				{children}
			</PTHead>
		);
	},
);
